import React, { useState, useEffect } from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";
import calc from "../../utils/calculation";

import lbl from "../../data/Labels.json";

const FinancePaymentsList = ({ activeYear, data }) => {
  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "payment_date", label: "تاریخ" },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    { path: "paid_by_staff_name", label: "پرداخت کننده" },
    { path: "modified_by_staff_name", label: "ثبت کننده" },
    { path: "remark", label: "ملاحظه" },
    { path: "amount", label: "مبلغ" },
    { path: "bank_ref_no", label: "ریفرنس نمبر" },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{ form: "staff-payment-form", cache: e.staff_id, edit: e }}
          Delete={{ route: "staff/payment", id: e.id }}
          Print={{ route: `staff-salary-receipt/${e.staff_id}/${e.id}`}}
        />
      ),
    },
  ];

  const [rows, getRows] = useState([]);

  useEffect(() => {
    if (data.data) {
      let _data = data?.data[0]?.payments.filter(
        (item) => item.half_year_id === activeYear.half_year_id
      );

      getRows(_data);
    }
  }, [activeYear]);

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payments}</p>
      <Table
        data={rows}
        columns={paymentsColumn}
        total={rows && calc.getTotal(rows, "amount")}
      />
    </div>
  );
};

export default FinancePaymentsList;
